import React from "react";
import { Link } from "react-router-dom";
import logofonasa1 from "../img/logofonasa1.svg";

function Header() {
  return (
    <>
    <div className="navbar navbar-light pt-4 bg-primary ">
      <div className="container">
        <div className="row ">
          <Link to={"/"} className="">
            <img src={logofonasa1} alt="" />
          </Link>
        </div>
      
        <hr />
      </div>
      </div>
    </>
  );
}
export default Header;

